import { render, staticRenderFns } from "./menu5_video_clip.vue?vue&type=template&id=c2a5c0f6&scoped=true"
import script from "./menu5_video_clip.vue?vue&type=script&lang=js"
export * from "./menu5_video_clip.vue?vue&type=script&lang=js"
import style0 from "./menu5_video_clip.vue?vue&type=style&index=0&id=c2a5c0f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a5c0f6",
  null
  
)

export default component.exports